import { Text } from '@mantine/core';
import './styles.scss';

interface DisplayFieldProps {
  title: string;
  content: React.ReactNode;
}

const DisplayField = ({ title: text, content }: DisplayFieldProps) => {
  return (
    <>
      <Text>{text}</Text>
      <div className="display-field-content">{content}</div>
    </>
  );
};

export default DisplayField;
